// import PubNub from 'pubnub'
import { useAppStore } from 'Store/app'
import { useSettingsStore } from 'Store/settings'
// import { removeSession, storeSession } from 'Utilities/Session'
// import { EventBus } from 'ChatWidget/EventBus'
// import { appendClosedToLocalStorage } from 'Utilities/ClosedIconMessages'

export default {
  pubnub: null,
  user: null,

  initialize(user) {
    this.user = user
    // this.pubnub = PubNub.init({
    //   send_by_post: true,
    //   subscribe_key: user.subscribe_key,
    //   publish_key: user.publish_key,
    //   auth_key: user.auth_key,
    //   uuid: `user-${user.id}`,
    //   ssl: true
    // })

    // this.setupListeners()
  },

  handleMessage(message) {
    // whenever CB on BW subdomain sends an anonymous_sign_in request
    // it will set the request's response to pubnub in order to
    // sync sign in/out state between CB on BW subdomain and CB on facility page
    // if (message.session && message.session !== store.getters['AppChat/getSession']) {
    //   const isSignOut = !message.user.known_user_signed_in
    //
    //   if (isSignOut) {
    //     removeSession()
    //     if (store.getters['AppChat/isChatWindowOpened']) {
    //       EventBus.$emit('toggle-chat')
    //     }
    //   }
    //
    //   store.dispatch('AppChat/setMinimized', false)
    //   storeSession(message.session)
    //   EventBus.$emit('refresh-chat')
    //   this.refreshBWLogin()
    // }
    //
    // if (message.toc_accepted) {
    //   store.dispatch('TermsConditionsModal/setAccepted', true)
    // } else if (message.hasOwnProperty('hideSignIn')) {
    //   store.dispatch('AppChat/setHideSignIn', message.hideSignIn)
    // } else if (message.hasOwnProperty('isMinimized')) {
    //   store.dispatch('AppChat/setMinimized', message.isMinimized)
    // } else if (message.closedIconMessage) {
    //   store.dispatch('IconMessage/closeIconMessage', message.closedIconMessage)
    //   appendClosedToLocalStorage(message.closedIconMessage)
    // }
  },

  setupListeners() {
    this.pubnub.addListener({
      presence: this.handlePresenceEvent
    })
  },

  subscribe() {
    // this.pubnub.subscribe({
    //   channel: [this.user.channel],
    //   message: (message) => {
    //     this.handleMessage(message)
    //   }
    // })
  },

  unsubscribe() {
    // this.pubnub.unsubscribe({ channel: this.pubnub.get_subscribed_channels() })
    // this.pubnub = null
  },

  setState(state) {
    if (!this.pubnub) return

    this.pubnub.publish({
      message: state,
      channel: this.pubnub.get_subscribed_channels(),
      store_in_history: false,
      post: true
    })
  },

  refreshBWLogin() {
    const appStore = useAppStore()
    const settingsStore = useSettingsStore()

    if (!settingsStore.isBWOpenInNewTab && !appStore.isOnBookingWidget) return

    const message = { action: 'refresh-login-from-chatbot' }
    const bwURL = settingsStore.bookingWidgetURL

    if (settingsStore.isBWOpenInNewTab) {
      // window origin !== bwURL means CB is on facility site instead of subdomain
      if (window.location.origin === bwURL) {
        window.postMessage(message, bwURL)
      }
    } else {
      const bwIframe = document.getElementById('tripla-booking-widget-window')
      bwIframe?.contentWindow.postMessage(message, bwURL)
    }
  }
}
